export default "/images/96fcb2c4aba1a83bd565b80931f9a65c.avif";